export default "__VITE_ASSET__8f037c3a__"